import React, { useEffect } from "react";
import ProductAreaRail from "web/react/components/product-area-rail/product-area-rail";
import analytics from "web/script/analytics/analytics";
import { ProductCardSerializer, RelatedProductsAreaSectionSerializer } from "web/types/serializers";

interface Designer {
    lystId: number;
    name: string;
}

interface NewArrivalsProps {
    title: string;
    products?: ProductCardSerializer[] | RelatedProductsAreaSectionSerializer;
    designer: Designer;
    isAuthenticated: boolean;
    isFollowing: boolean;
}

function NewArrivals({
    title,
    products,
    designer,
    isAuthenticated,
    isFollowing,
}: NewArrivalsProps): React.ReactElement {
    useEffect(() => {
        analytics.event("new_arrivals", "shown");
    }, []);

    return (
        <ProductAreaRail
            showFollowCTA
            title={title}
            products={products}
            designer={designer}
            isAuthenticated={isAuthenticated}
            isFollowing={isFollowing}
        />
    );
}

export default NewArrivals;
